import React from 'react';
import { MobilePayCheckout as MobPayCheckout } from 'cb-design-system';
import { connect, ReactReduxContext } from 'react-redux';


const MobilePayCheckout = (props) => {
            return (

                <MobPayCheckout
                    {...props}
                />
            )
}



export default MobilePayCheckout;